import React, { useState } from 'react';
import styles from './ECardNewFilesListWrapper.module.scss';
import ECardNewFilesListFilter from './ECardNewFilesListFilter';
import ECardNewFilesList from './ECardNewFilesList';
import useFlatData from '../../../Base/Hooks/useFlatData';
import useWorkplacePatientsFiles from '../../Hooks/useWorkplacePatientsFiles';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import useECardNewFiles from '../../Hooks/useECardNewFiles';

export interface ECardNewFileSelectedItem {
	id: string;
	folderId: string;
	patientId: string;
}

const ECardNewFilesListWrapper: React.FC = () => {
	const { getDocumentationFiles, getNextPage, data, isLoading, page, setPage } =
		useWorkplacePatientsFiles();

	const { markAsSeen, markAsAllSeen } = useECardNewFiles();

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getDocumentationFiles,
		{
			data: data?.workplacePatientDocumentationFiles?.data,
			totalPages: data?.workplacePatientDocumentationFiles?.meta?.totalPages,
			page: data?.workplacePatientDocumentationFiles?.meta?.page,
		},
		page,
		setPage,
		{},
	);

	const [isAllChecked, setIsAllChecked] = useState(false);
	const [selectedItems, setSelectedItems] = useState<
		ECardNewFileSelectedItem[]
	>([]);

	const handleCheckAllItems = () => {
		setIsAllChecked(prev => !prev);
		if (isAllChecked) {
			setSelectedItems([]);
		}
	};

	const handleAddItemToSelected = (
		item: ECardNewFileSelectedItem,
		add: boolean,
	) => {
		if (!item) {
			return null;
		}
		setSelectedItems(prev => {
			if (add) {
				return [...prev, item];
			}
			return prev.filter(({ id }) => id !== item.id);
		});
	};

	const handleMarkAsSeen = async () => {
		if (isAllChecked) {
			await markAsAllSeen();
		} else {
			await markAsSeen(selectedItems);
		}
		loadData(true);
	};

	return (
		<div className={styles.wrapper}>
			<ECardNewFilesListFilter onFilter={setFilter} />
			<div className={styles.options}>
				<Checkbox
					tx={'base.everything'}
					value={isAllChecked}
					onChange={handleCheckAllItems}
					firstUpper
				/>
				<div className={styles.seenWrapper}>
					<img src={'/dist/icons/eye.svg'} />
					<LinkButton
						title={'base.markAsSeen'}
						theme={Theme.BLUE}
						onClick={handleMarkAsSeen}
					/>
				</div>
			</div>
			<ECardNewFilesList
				flatData={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
				onItemSelect={handleAddItemToSelected}
				isAllSelected={isAllChecked}
			/>
		</div>
	);
};
export default ECardNewFilesListWrapper;
